module.exports = __webpack_public_path__ + "static/img/www.isoftfactory.com.4c4dace.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/www.isoftfactory.com.svg
// module id = TsBu
// module chunks = 98